import { Box, Dialog, DialogTitle } from "@mui/material";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import NoteTable from "./note-table";
import * as noteSlice from "../note.slice";
import { NoteTargetType } from "../../../shared/enums";
import { Note, NoteCreateRequest, NoteSearchCriteria } from "../../../service/model/note.model";
import NoteForm from "./note-form";
import { Member } from "../../../service/model/member.model";
import { BusinessUser } from "../../../service/model/user.model";
import FormCloseButton from "../../../components/form-controls/form-close-button";
import CreateButton from "../../../components/create-button";

interface NoteModalProps {
    readonly target: Member | BusinessUser
    readonly targetType: NoteTargetType
    readonly onClose: () => void
}

const NoteModal: React.FC<NoteModalProps> = ({ target, targetType, onClose }) => {
    const dispatch = useAppDispatch();
    const notes = useAppSelector(noteSlice.selectNotes);
    const [showNoteForm, setShowNoteForm] = useState(false);

    const onSubmitHandler = (data: any) => {
        const request = {
            content: data.content,
            targetType: targetType,
            targetId: target.id,
            dueDate: data.dueDate,
        } as NoteCreateRequest;
        dispatch(noteSlice.createNote(request))
        onClose();
    };

    useEffect(() => {
        const searchCriteria = {
            pagination: {
                page: 0,
                size: 10
            },
            targetId: target.id,
            // from: addDays(new Date(), -30).toISOString().slice(0, 10),
            // to: new Date().toISOString().slice(0, 10),
        } as NoteSearchCriteria;
        if (targetType === NoteTargetType.MEMBER) {
            dispatch(noteSlice.fetchNotesByMember(searchCriteria));
        } else if (targetType === NoteTargetType.STAFF) {
            dispatch(noteSlice.fetchNotesByUser(searchCriteria));
        }
    }, []);

    const getFilteredNotesByTargetId = (): Note[] => {
        if (targetType === NoteTargetType.MEMBER) {
            return notes.filter(note => note.targetId === target.id && note.targetType === NoteTargetType.MEMBER);
        } else if (targetType === NoteTargetType.STAFF) {
            return notes.filter(note => note.targetId === target.id && note.targetType === NoteTargetType.STAFF);
        }
        return [];
    }

    return (
        <Dialog open={true} onClose={onClose} sx={{ p: 2 }} fullWidth maxWidth="md">
            <DialogTitle>Note Details</DialogTitle>

            {showNoteForm &&
                <NoteForm editable={true} targetType={targetType} targetId={target.id} onClose={() => setShowNoteForm(false)} onSubmit={onSubmitHandler} />
            }
            <Box sx={{ p: 2 }}>
                <>
                    <FormCloseButton onClose={onClose} />
                    <Box sx={{ mb: "12px" }}>
                        <CreateButton variant="contained" onClick={() => setShowNoteForm(true)} style={{ marginBottom: "12px" }}>Add Note</CreateButton>
                    </Box>
                </>
                <NoteTable notes={getFilteredNotesByTargetId()} />
            </Box>
        </Dialog>
    );
}

export default NoteModal;